import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TabLinkItem } from '@api-ui-app/src/app/shared/lib/tab-link-item';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: true,
  selector: 'ui-tab-links',
  templateUrl: './tab-links.component.html',
  styleUrls: ['./tab-links.component.scss'],
  imports: [RouterLink, TranslateModule, NgIf, NgForOf, RouterLinkActive, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabLinksComponent {
  @Input() items: TabLinkItem[] = [];
  @Input() showLoadingState = false;

  @Input() set loadingItemsNumber(number: number) {
    this.loadingItems$.next(this.getLoadingItemsSizes(number));
  }

  defaultLoadingItemsNumber = 3;
  loadingItems$ = new BehaviorSubject<number[]>(this.getLoadingItemsSizes(this.defaultLoadingItemsNumber));

  onClick(item: TabLinkItem): void {
    if (item?.onClick) {
      item.onClick();
    }
  }

  // return random loading state placeholder size between 30 and 140 px
  getLoadingItemsSizes(itemsNumber: number): number[] {
    // The lower limit of the random numbers.
    const lowerLimit = 30;
    // The range of the random numbers.
    const range = 110;
    return Array(itemsNumber)
      .fill(0)
      .map(() => Math.floor(Math.random() * range) + lowerLimit);
  }
}
